// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  documentUploadSpace: 200.00,
  staticFileLocation: '/documents/',
  marketingSiteUrl: 'www.theelectronicguardian.com',
  maxDocumentSize: 20.00,
  acceptedVideoFileTypes: [
    '.webm', '.flv', '.swf', '.flv', '.vob',
    '.avi', '.mts', '.m2ts', '.ts', '.mov',
    '.qt', '.wmv', '.rm', '.rmvb', '.amv',
    '.mp4', '.m4p', '.m4v', '.mpg', '.mp2',
    '.mpeg', '.mpe', '.mpv', '.mpg', '.mpeg',
    '.m2v', '.m4v', '.3gp', '.3g2', '.nsv',
    '.flv', '.f4v', '.f4p', '.f4a', '.f4b',
    '.ogg',
  ],
  sessionUpdateCallIntervalTime: 5 * 60 * 1000,
  fileStatusRefreshIntervalTime: 30 * 1000,
  payDiscountErrorTryCount: 6,
  stripeCustomerPortal: 'https://billing.stripe.com/p/login/14kcN48lR2cd0PSbII',
  paypalCustomerLogin: '://www.paypal.com/signin',
  googleAnalyticsID: "G-K773EVTRHB",
  facebookPixelID: "551591810215145",
  hotJarAnalytics: {
    id: 3382960,
    version: 6
  },
  usersTablePageSize: 250,
  notesTablePageSize: 2,
  clienturl: "https://account.theelectronicguardian.com",
  fileUploadChunkSize: 1024 * 1024 * 8,
  retrunFromStripe: '/dashboard/vault-open'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
